import { Route } from "react-router-dom";
import Leave from "../features/leave/components/absences/Parent";
// Leave routes
export const leaveRoutes = (
    <Route path="/leave" element={<Leave />} key="leave" />
);
